/**
 * 服务
 */
export const enum SERVICE {
  VAYH_API = 'vayhapi',
  FIN_ICR = 'icr',
  FIN_ACR = 'acr',
}

/**
 * 统一服务前缀 可以移动到配置文件中
 */
export const SERVICE_PREFIX = '';

/**
 * 请求路径连接符
 */
export const PATH_CONNECTOR = '/';
